import React, { useState } from "react";
import { IconButton } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import CustomDialog from "../../../../../components/Dialog/DiaComp";
import { TextInsulin } from "./TextInsulin";
import { SourcesInsulin } from "./SourcesInsulin";


export default function DiaTextInsulin() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <div>

        <IconButton onClick={handleOpen} size="small" >
            <InfoIcon sx={{fontSize: '160%', color: 'background.iconlight', '&:hover': { color: 'primary.light'}, }}/>
        </IconButton>   
      
        <CustomDialog open={open} onClose={handleClose}

          title="INSULIN & MICROBIOME"

          content={ <TextInsulin />}
          
          sources={ <SourcesInsulin /> }
        />
      </div>
    );
  }